import { useMemo } from "react";

const useActiveFilterCount = (searchFilters) =>
	useMemo(
		() =>
			(searchFilters || []).reduce((count, group) => {
				if (!group || !group.options) return count;
				return (
					count +
					Object.values(group.options).filter((option) => option.checked)
						.length
				);
			}, 0),
		[searchFilters]
	);

export default useActiveFilterCount;
